import { createVuetify } from "vuetify";
import { ru } from "vuetify/locale";
import "vuetify/styles";
import "./vuetify.css";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

export default createVuetify({
  components,
  directives,
  defaults: {
    VCheckbox: {
      ripple: false, // временное решение для чекбоксов, потому что ripple делает мозги
    },
  },
  theme: {
    defaultTheme: "light",
    disable: true,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        colors: {
          primary: "#ffffff",
          secondary: "#424242",
          accent: "#82B1FF",
          error: "#FF5252",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FFC107",
        },
      },
    },
  },
  locale: {
    locale: "ru",
    messages: { ru },
  },
});
